import { useProfilesData } from '@/features/user/api';

import { AllFeatureItems, FeatureEnumType, getTemplate } from './index';

const useFeature = ({
  feature,
  featureItem,
}: {
  feature: FeatureEnumType;
  featureItem: AllFeatureItems;
}): boolean => {
  const { selectedCourse } = useProfilesData();

  const template = getTemplate(selectedCourse?.product_name as string);

  // Type assertion needed because TypeScript can't correlate the relationship
  // between feature type and featureItem type
  return (
    (template[feature] as readonly AllFeatureItems[])?.includes(featureItem) ??
    false
  );
};

export default useFeature;
